import React, { useEffect, useState } from "react";
import ContentPage from "../Components/ContentPage";
import HomeIcon from "@mui/icons-material/Home";
import ManageAccountsTwoToneIcon from "@mui/icons-material/ManageAccountsTwoTone";
import DataTable from "../Components/Table/DataTable";
import {
  userGroupCreate,
  userGroupDelete,
  userGroupList,
  userGroupUpdate,
} from "../store/Slice/userGroupSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Button,
  Checkbox,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import EditTwoToneIcon from "@mui/icons-material/EditTwoTone";
import DeleteSweepTwoToneIcon from "@mui/icons-material/DeleteSweepTwoTone";
import SearchTwoToneIcon from "@mui/icons-material/SearchTwoTone";
import AddCircleTwoToneIcon from "@mui/icons-material/AddCircleTwoTone";
import { useFormik } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import CloseIcon from "@mui/icons-material/Close";
import SaveAltIcon from "@mui/icons-material/SaveAlt";

export default function UserGroupList() {
  const dispatch = useDispatch();
  const userGroup = useSelector(({ userGroup }) => userGroup);
  useEffect(() => {
    dispatch(userGroupList());
  }, []);
  const [search, setSearch] = useState({
    search: "",
  });
  const [open, setOpen] = React.useState(false);

  const permission_list = [
    {
      name: "เมนู",
      permission: [
        {
          key: "ALL_LAB_REQUEST",
          name: "All Lab Request",
          status: false,
        },
        {
          key: "USER",
          name: "ผู้ใช้งาน",
          status: false,
        },
        {
          key: "USERS_GROUP",
          name: "กลุ่มผู้ใช้งาน",
          status: false,
        },
        {
          key: "DEPARTMENT",
          name: "จุดตรวจ",
          status: false,
        },
        {
          key: "LAB_FORM",
          name: "Lab Form",
          status: false,
        },
        {
          key: "SETTING",
          name: "ตั้งค่า",
          status: false,
        },
      ],
    },
  ];

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: "",
      group_name: "",
      group_dis: "",
      permission: permission_list,
    },
    validationSchema: Yup.object().shape({
      group_name: Yup.string().required("ระบุชื่อ"),
    }),
    onSubmit: (values) => {
      if (values.id) {
        dispatch(userGroupUpdate(values)).then(() => {
          dispatch(userGroupList());
          handleClose();
        });
      } else {
        dispatch(userGroupCreate(values)).then(() => {
          dispatch(userGroupList());
          handleClose();
        });
      }
    },
  });

  const handleClickEdit = (data) => {
    formik.setFieldValue("id", data.id);
    formik.setFieldValue("group_name", data.group_name);
    formik.setFieldValue("group_dis", data.group_dis);

    // Merging the permissions
    const mergedPermissionList = permission_list.map((list1) => {
      const list2 = data.permission.find((list) => list.name === list1.name);

      if (list2) {
        const mergedPermissions = list1.permission.map((perm1) => {
          const perm2 = list2.permission.find((perm) => perm.key === perm1.key);
          return {
            ...perm1,
            status: perm2 ? perm2.status : perm1.status,
          };
        });

        return {
          ...list1,
          permission: mergedPermissions,
        };
      }

      return list1;
    });
    formik.setFieldValue("permission", mergedPermissionList);
    handleClickOpen();
  };

  const onClickSearch = () => {
    dispatch(userGroupList(search));
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const rows = userGroup.result;
  const columns = [
    {
      field: "#",
      headerName: "#",
      width: 30,
    },
    {
      field: "group_name",
      headerName: "กลุ่มผู้ใช้งาน",
    },
    {
      field: "group_dis",
      headerName: "รายละเอียด",
    },
    {
      field: "actions",
      headerName: "Actions",
      numeric: "center",
      renderCell: ({ row }) => {
        return (
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Button
              variant="contained"
              startIcon={<EditTwoToneIcon />}
              sx={{ mr: 2 }}
              onClick={() => handleClickEdit(row)}
            >
              แก้ไข
            </Button>
            <Button
              variant="contained"
              startIcon={<DeleteSweepTwoToneIcon />}
              color="error"
              onClick={() => {
                Swal.fire({
                  title: "คุณต้องการลบข้อมูลหรือไม่",
                  text: row.name,
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#FF8C00",
                  cancelButtonColor: "#FF4500",
                  confirmButtonText: "ยืนยัน",
                  cancelButtonText: "ยกเลิก",
                  customClass: {
                    title: "sweetalert-title", // Apply Sarabun font to the title
                    content: "sweetalert-content", // Apply Sarabun font to the content
                    confirmButton: "sweetalert-confirm-button",
                    cancelButton: "sweetalert-cancel-button",
                  },
                }).then((result) => {
                  if (result.isConfirmed) {
                    dispatch(userGroupDelete({ id: row.id })).then(() => {
                      dispatch(userGroupList());
                    });
                    Swal.fire({
                      title: "ลบ!",
                      text: "ลบข้อมูลเรียบร้อย",
                      icon: "success",
                    });
                  }
                });
              }}
            >
              ลบ
            </Button>
          </Box>
        );
      },
    },
  ];

  return (
    <Container maxWidth={"xl"}>
      <ContentPage
        image_icon={process.env.PUBLIC_URL + "/icons/group_account.png"}
        title="กลุ่มผู้ใช้งาน"
        TitlePageMenulist={[
          {
            label: "หน้าแรก",
            href: "/lab",
            icon: <HomeIcon fontSize="small" />,
          },
          {
            label: "Data Master",
            href: "#",
            icon: <ManageAccountsTwoToneIcon fontSize="small" />,
          },
          {
            label: "กลุ่มผู้ใช้งาน",
            href: "/lab/user-group",
            icon: <ManageAccountsTwoToneIcon fontSize="small" />,
          },
        ]}
        btnAction={
          <Button
            variant="contained"
            startIcon={<AddCircleTwoToneIcon />}
            onClick={handleClickOpen}
          >
            เพิ่มกลุ่มผู้ใช้งาน
          </Button>
        }
      >
        <Paper elevation={0} sx={{ p: 1 }}>
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="flex-start"
            spacing={2}
            mb={2}
          >
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                id="outlined-basic"
                type="search"
                value={search.search}
                label="ค้นหา"
                size="small"
                variant="outlined"
                onChange={(e) => {
                  setSearch({
                    ...search,
                    search: e.target.value,
                  });
                }}
              />
            </Grid>
            <Grid item xs={12} md={1}>
              <Button
                variant="contained"
                fullWidth
                startIcon={<SearchTwoToneIcon />}
                onClick={onClickSearch}
              >
                ค้นหา
              </Button>
            </Grid>
          </Grid>
          <DataTable columns={columns} rows={rows} />
        </Paper>
        <Dialog
          open={open}
          fullWidth
          maxWidth={"md"}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          component={"form"}
          onSubmit={formik.handleSubmit}
        >
          <DialogTitle id="alert-dialog-title">
            {formik.values.id ? "แก้ไข" : "เพิ่ม"}กลุ่มผู้ใช้งาน
          </DialogTitle>
          <DialogContent>
            <Grid
              container
              direction={"row"}
              justifyContent={"flex-start"}
              spacing={2}
            >
              <Grid item xs={12} md={12}>
                <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                  ข้อมูล
                </Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  id="group_name"
                  name="group_name"
                  value={formik.values.group_name}
                  label="กลุ่มผู้ใช้งาน"
                  size="small"
                  variant="outlined"
                  onChange={formik.handleChange}
                  error={Boolean(formik.errors.group_name)}
                  helperText={formik.errors.group_name}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  id="group_dis"
                  name="group_dis"
                  value={formik.values.group_dis}
                  label="รายละเอียด"
                  size="small"
                  variant="outlined"
                  onChange={formik.handleChange}
                />
              </Grid>
              <Grid item xs={12} md={12}>
                <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                  เมนู
                </Typography>
              </Grid>
              <Grid item xs={12} md={12}>
                <Paper variant="outlined" sx={{ p: 2 }}>
                  <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                    สิทธิการใช้งาน
                  </Typography>
                  <Divider />
                  <Grid container direction={"row"} spacing={2} mt={1}>
                    {formik.values.permission.map((opt, index) => (
                      <Grid item key={index} xs={12} md={6}>
                        <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                          {opt.name}
                        </Typography>
                        <FormGroup>
                          {opt.permission.map((p, i) => (
                            <FormControlLabel
                              key={i}
                              control={<Checkbox defaultChecked={p.status} />}
                              label={p.name}
                              onChange={(e) => {
                                formik.setFieldValue(
                                  `permission[${index}].permission[${i}].status`,
                                  e.target.checked
                                );
                              }}
                            />
                          ))}
                        </FormGroup>
                      </Grid>
                    ))}
                  </Grid>
                </Paper>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              onClick={handleClose}
              color="error"
              startIcon={<CloseIcon />}
            >
              ปิด
            </Button>
            <Button
              variant="contained"
              type="submit"
              autoFocus
              startIcon={<SaveAltIcon />}
            >
              {formik.values.id ? "อัพเดท" : "บันทึก"}
            </Button>
          </DialogActions>
        </Dialog>
      </ContentPage>
    </Container>
  );
}
